module.exports={
  base_url:"https://db-bank-api.komunestudio.com"
  // base_url:"https://bn-api.cimbvrlearning.id/"
  // base_url:"https://bn-api.cimbvrlearning.id/"
  // base_url:"http://wellworld.id:18223"
};
